import React from 'react'

const ModalInfoCard = ({
  icon: IconComponent,
  title,
  value,
  size
}) => {
  return (
    <div className="rounded-lg border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
        <div className="flex flex-row items-center text-gray-700">
          <IconComponent style={{ fontSize: "18px" }} />
          <span className="ml-2 text-sm font-medium text-gray-700">
            {title}
          </span>
        </div>
      </div>
      <div className="px-4 py-3">
        <span className={`${size === "small" ? "text-sm" : "text-base"} font-medium text-gray-900`}>
          {value}
        </span>
      </div>
    </div>
  );
};

export default ModalInfoCard;
